// libraries
import React from 'react';
import { IoIosArrowForward } from 'react-icons/io';
// utils
import Link from 'next/link';
import { completarURL, hexToRgba, isColorLight } from '../../utils/FunctionsGlobals';
import styles from './HistoryComponent.module.css';

const HistoryComponent: React.FC<{
    routes: Array<string>;
    site: any;
    pagina?: any
}> = ({ routes, pagina,site }): any => {
    // constants
    const removeEmpty = routes?.filter((v) => v !== '-' && v !== '1');
    const cor_font = isColorLight(site?.cor5) ? site?.cor11 : site?.cor13; 
    return (
        <div className={pagina == 3 ? styles.container3 : styles.container} style={{background: site?.cor5,borderBottom: `1px solid ${hexToRgba(cor_font,0.1)}`}}>
            <ul className={pagina == 1 || pagina == 3 ? styles.body1 : styles.body}>
                {removeEmpty?.map((v, i) => {
                    const formatLabel = `${v
                        .substring(0, 1)
                        .toUpperCase()}${v.substring(1, v.length)}`
                        .replaceAll('-', ' ')
                        .replaceAll('+', ',');
                    const renderPath = () => {
                        if (v === 'home') {
                            return '/';
                        }
                        if (v === 'blog') {
                            return '/blog';
                        }
                        if (v === 'imóveis') {
                            return '/imoveis/venda/-/-/-/-';
                        }
                        if (v === 'venda') {
                            return '/imoveis/venda/-/-/-/-';
                        }
                        if (v === 'aluguel') {
                            return '/imoveis/aluguel/-/-/-/-';
                        }
                        if (v === 'temporada') {
                            return '/imoveis/temporada/-/-/-/-';
                        }
                        if (v === 'condomínios') {
                            return '/condominios';
                        }
                        if (v !== '-') {
                            const removeRoutes = routes
                                .filter((v) => !['home', 'imóveis'].includes(v))
                                .join()
                                .split(v)[0]
                                .replaceAll(',', '/');
                            return `/imoveis/${removeRoutes}${v}`;
                        }
                        return '/imoveis/-/-/-/-';
                    };
                    if (removeEmpty?.length - 1 !== i) {
                        let url = renderPath()
                        const contador = url.split('/').length - 1;
                        if(contador > 1 && contador < 6){
                            url = completarURL(url)
                        }
                        return (
                            <li className={styles.li} key={v}>
                                <Link href={url} key={v} title={`Direcionar para ${formatLabel}`}>
                                    <div className={styles.tag_active}>
                                        <div className={styles.text_normal} style={{color: cor_font}}>
                                            {formatLabel}
                                        </div>
                                        <IoIosArrowForward
                                            size={10}
                                            color={cor_font}
                                        />
                                    </div>
                                </Link>
                            </li>
                        );
                    }
                    return (
                        <li key={v} className={styles.li} id="atual">
                            <div className={styles.text_focus}>{formatLabel}</div>
                        </li>
                    );
                })}
            </ul>
        </div>
    );
};

export default HistoryComponent;
